import defaultTheme from './default-theme';
export var theme = defaultTheme;
export * from './theme.types';
export * from './extend-theme';
export * from './css-reset';
export * from './tqc-provider';
export default theme;